import { render } from "./CustomerTarifChangeList.vue?vue&type=template&id=3e52b037&scoped=true"
import script from "./CustomerTarifChangeList.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerTarifChangeList.vue?vue&type=script&setup=true&lang=js"

import "./CustomerTarifChangeList.vue?vue&type=style&index=0&id=3e52b037&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e52b037"],['__file',"resources/js/components/CustomerTarifChangeList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e52b037"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e52b037', __exports__)) {
    api.reload('3e52b037', __exports__)
  }
  
  module.hot.accept("./CustomerTarifChangeList.vue?vue&type=template&id=3e52b037&scoped=true", () => {
    api.rerender('3e52b037', render)
  })

}


export default __exports__